import { deprecatedLocaleRedirects, type Locale, locales } from "../lib/shared/constants";

const supportedLocaleSet = new Set<string>(locales);

export const payloadFallbackLocale: Locale = "en";

export function isSupportedLocale(value: string): value is Locale {
  return supportedLocaleSet.has(value);
}

/** Payload `find` locale param after route/middleware validation. */
export function toPayloadLocale(locale: string): Locale {
  return locale as Locale;
}

export function resolveDeprecatedLocaleRedirect(pathname: string): {
  destinationPath: string;
} | null {
  const segments = pathname.split("/").filter(Boolean);
  const segment = segments[0];
  if (!segment) {
    return null;
  }

  const targetLocale = deprecatedLocaleRedirects[segment];
  if (!targetLocale) {
    return null;
  }

  const restPath = segments.slice(1).join("/");
  const destinationPath = restPath ? `/${targetLocale}/${restPath}` : `/${targetLocale}`;

  return { destinationPath };
}

export function buildNextDeprecatedLocaleRedirects(): Array<{
  source: string;
  destination: string;
  permanent: true;
}> {
  return Object.entries(deprecatedLocaleRedirects).map(([locale, target]) => ({
    source: `/${locale}/:path*`,
    destination: `/${target}/:path*`,
    permanent: true,
  }));
}

/** Maps removed locale codes to their redirect target; passes through supported locales. */
export function normalizeUserLanguage(
  language: string | null | undefined,
  fallback: string,
): string {
  if (!language) {
    return fallback;
  }

  if (isSupportedLocale(language)) {
    return language;
  }

  const redirect = deprecatedLocaleRedirects[language];
  if (redirect) {
    return redirect;
  }

  return fallback;
}
